import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PNLReportUseCase extends BaseUseCase {
    constructor(pnlReportRepo) {
        super();
        this.pnlReportRepo = pnlReportRepo;
    }
    async fetchResult(requestData) {
        const pnlReportData = await this.pnlReportRepo.getPNLReportData(requestData);
        return pnlReportData;
    }
}
export default PNLReportUseCase;
